<template>
    <v-chip
        label
        small
        :class="['pl-1 attachment-chip font-weight-medium', fullWidth ? 'w-100' : '']"
        :color="color"
        @click="$emit('click', file)"
    >
        <span :class="['px-2 mr-2 attachment-ext ', $options.filters.file_color(file.file_name, true)]">
            {{ file.file_name | file_extension }}
        </span>
        <span class="attachment-name">
            {{ file.file_name | file_name_max_len(30) }}
        </span>
    </v-chip>
</template>

<script>
import Vue from "vue";
import { $t } from "@/i18n";
import axios from 'axios'

export default {
    name: "AttachmentsChip",
    props: {
        file: {
            type: Object,
            required: true
        },
        color: {
            type: String,
            default: "n1"
        },
        fullWidth: {
            type: Boolean,
            default: true
        }
    },
    setup() {

        return {
        };
    }
};
</script>
<style lang="scss" scoped>
::v-deep .v-chip {
    color: var(--v-n5-base);

    .v-icon:before {
        visibility: hidden;
        color: var(--v-primary-base) !important;
    }

    &:hover {
        color: var(--v-primary-base);

        .v-icon:before {
            visibility: visible;
        }
    }
}
</style>
